// @flow
import { colors } from '@components/shared/colors'
import * as React from 'react'
import { Col, Container, Row, config } from 'react-awesome-styled-grid'
import styled from 'styled-components'
import { H1, P } from '../shared/typography'
import BackgroundGradient from '@components/BackgroundGradient'

type PropsType = {
  loaded: () => void,
  headerText: string,
  descriptionText: string,
  cta: React.Node
}

export default function GiftHeader (props: PropsType): React.Node {
  const { loaded, headerText, descriptionText, cta } = props

  return (
    <Section>
      <BackgroundGradient
        loadingComplete={loaded}
        quadrant={3}
        gradientColor={colors.midnightBlue}
        gradientPosition='bottom'
        parallax
      />
      <Main>
        <Container>
          <Row justify='center'>
            <Col xs={4} sm={8} md={8} lg={10}>
              <HeaderTextContainer>
                <HeaderText dangerouslySetInnerHTML={{ __html: headerText }} />
                <Description>{descriptionText}</Description>
                {cta}
              </HeaderTextContainer>
            </Col>
          </Row>
        </Container>
      </Main>
    </Section>
  )
}
const Section = styled.section`
  margin: -75px 0 0;
  overflow: hidden;
  position: relative;
`
const Main = styled.div`
  align-items: center;
  display: flex;
  padding: 170px 0;
  min-height: 300px;
  height: 50vh;
`
const HeaderTextContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 60px 0;
`
const HeaderText = styled(H1)`
  color: ${colors.sand};
  font-family: 'Queens Condensed Light';
  font-size: 60px;
  font-weight: 300;
  letter-spacing: -0.009em;
  line-height: 1.2em;
  margin: 0 0 0.5em 0;
  text-align: center;
  ${(props: any): string => config(props).media.lg`
    font-size: 90px;
    line-height: 1.05em;
    margin: 0 0 .2em 0;
  `}
`
const Description = styled(P)`
  color: ${colors.sand};
  font-size: 16px;
  line-height: 1.5em;
  margin: 0 0 1.5em;
  text-align: center;
  ${(props: any): string => config(props).media.lg`
    font-size: 18px;
    margin: 0 0 1.5em;
  `}
`
